import { useMemo } from 'react';
import { theme } from 'antd';

const cssVar = (name: string, fallback: string) => {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

export const useChartTheme = () => {
  const { token } = theme.useToken();

  return useMemo(
    () => ({
      grid: token.colorBorderSecondary,
      cursor: token.colorFillQuaternary,
      tick: { fontSize: 11, fill: token.colorTextTertiary },
      series: [
        cssVar('--accent', '#3b82f6'),
        cssVar('--success', '#22c55e'),
        cssVar('--accent-cyan', '#06b6d4'),
        cssVar('--danger', '#f87171'),
        cssVar('--accent-sky', '#0ea5e9'),
      ],
    }),
    [token],
  );
};